import React from "react"

import * as styles from "./electronic-invoicing.module.css"

const ElectronicInvoicing = ({ heading, body }) => (
  <div className={styles.wrapper}>
    <div className="container">
      <div className="columns">
        <div className="column is-offset-2-desktop">
          <div className={styles.content}>
            <h2>{heading}</h2>
            <p>
              {body.map((line, index) => (
                <span key={index}>{line}</span>
              ))}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default ElectronicInvoicing
